import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useResultsChallenge = (id, enabled = true) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['resultsChallenge', id],
    queryFn: async () => {
      const result = await restClient({ 
        url: `${prefix}/results/challenge/${id}`, 
        method: 'get'
      });
      return result;
    },
    enabled: enabled && !!id, // Enable only if we have an id
    staleTime: 0, 
    cacheTime: 0, 
    refetchOnWindowFocus: false
  });
};
